module.exports = __webpack_public_path__ + "img/ek-tanerolmez-eba@2x.49ce36d2.png";